// Handler to clear the selected date
export const clearSelectedDate = (onChange, defaultDate = null) => {
    onChange(defaultDate);
};
